import { memo, useRef, useState } from "react";
import { useSelector } from "react-redux";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import InsertInvitationIcon from "@mui/icons-material/InsertInvitation";
import { LoadingButton } from "@mui/lab";
import {
  Box,
  Grid,
  IconButton,
  InputAdornment,
  Modal,
  Stack,
  TextField,
  Typography
} from "@mui/material";
import { LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { Fileuploadrequestcall } from "../../request/Fileuploadrequest";
import { Postrequestcall } from "../../request/Postrequest";
import {
  SAVE_CLIENT_CHANGE_TRACKER,
  SAVE_CLIENT_CHANGE_TRACKER_PICTURES
} from "../../constant/Apipath";
import { BIGrey, BILightGrey } from "../../assets/helpers";
import PictureViewer from "../../common/PictureViewer";
import { ClientEnglishFallback } from "../constant/ClientEnglishFallback";

export default function ClientChangeTrackerAddModel({ isOpen, onClose, data, reload }) {
  const { loginData, selectedClientData, multiLanguageData } = useSelector((state) => state?.main);
  const LANGUAGE = ClientEnglishFallback.ClientChangeTrackerAddModel(
    multiLanguageData?.ClientChangeTrackerAddModel || {}
  );
  const { TEXT_JOB, TEXT_DATE, TEXT_DESCRIPTION, TEXT_CHANGE_IS_REQUIRED, TEXT_SUBMIT } = LANGUAGE;
  const imgRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [description, setDescription] = useState("");
  const [index, setIndex] = useState(null);

  const [uploadedImageList, setUploadedImageList] = useState([]);
  const [date, setDate] = useState(dayjs());
  const [pictureView, setPictureView] = useState(false);
  const [open, setOpen] = useState(false);

  const handleAddImage = () => {
    imgRef.current.click();
  };

  const handelsaveClientTracker = async () => {
    setLoading(true);
    try {
      let obj = {
        UserId: loginData?.userInformation?.UserId,
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            Id: 0,
            ClientEmployeeId: data?.clientEmployeeId || selectedClientData?.ClientEmployeeId,
            ClientEmployeeJobId: data?.id,
            Date: date ? dayjs(date).format("YYYY-MM-DD") : dayjs().format("YYYY-MM-DD"),
            Description: description,
            ModifiedBy: loginData?.userInformation?.UserId
          }
        ]
      };

      let res = await Postrequestcall(SAVE_CLIENT_CHANGE_TRACKER, obj, loginData?.accessToken);

      let id_for_Img = res?.data?.data[0]?.objData.id;

      if (uploadedImageList?.length > 0 && id_for_Img) {
        let formDataArray = uploadedImageList?.map((img) => {
          let formData = new FormData();
          formData.append("file", img);
          formData.append("id", 0);
          formData.append("ChangeTrackerId", id_for_Img);
          formData.append("ModifiedBy", loginData?.userInformation?.UserId);
          return formData;
        });

        let promises = formDataArray?.map((formData) =>
          Fileuploadrequestcall(
            SAVE_CLIENT_CHANGE_TRACKER_PICTURES,
            formData,
            loginData?.accessToken
          )
        );

        await Promise.all(promises);
      }
    } catch (error) {
      setLoading(false);
      console.log(`handelsaveClientTracker-> Error When Saving Client Change Tracker: `, error);
    } finally {
      reload();
      onClose();
      resetData();
    }

    setLoading(false);
  };

  const handleImageChange = (event) => {
    let temp = [...uploadedImageList];
    let files = event.target.files;
    for (let i = 0; i < files?.length; i++) {
      temp.push(files[i]);
    }
    setUploadedImageList(temp);
    event.target.value = "";
  };

  const handleRemoveImage = (picture, index) => {
    setUploadedImageList((prev) => prev.filter((_, idx) => idx != index));
  };

  const resetData = () => {
    setUploadedImageList([]);
    setDescription("");
    setDate(null);
    setLoading(false);
  };

  return (
    <>
      <Modal
        open={isOpen}
        onClose={() => {
          resetData();
          onClose();
        }}>
        <div className="client-modal-responsive">
          <div className="action-button-container">
            <IconButton
              onClick={() => {
                resetData();
                onClose();
              }}
              sx={{
                color:
                  selectedClientData?.AccentColor !== undefined && selectedClientData?.AccentColor
                    ? selectedClientData?.AccentColor
                    : BILightGrey
              }}>
              <CloseIcon />
            </IconButton>
          </div>
          <Stack
            padding={{
              xs: 0,
              sm: 0,
              md: 0.5,
              lg: 0.5,
              xl: 1
            }}>
            <Grid container display={"flex"} flexDirection={"column"}>
              <Grid>
                <Typography
                  margin={0}
                  style={{
                    color: BIGrey
                  }}
                  variant="subtitle1"
                  gutterBottom>
                  {TEXT_JOB}
                </Typography>
                <Typography>{`${data?.jobCode} - ${data?.jobName}`}</Typography>
              </Grid>

              <Grid>
                <Typography margin={0} variant="subtitle1" gutterBottom>
                  {TEXT_DATE}
                </Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  {/* Custom display field */}
                  <Box
                    onClick={() => setOpen(true)}
                    sx={{
                      height: "40px",
                      backgroundColor: "#e4e4e4",
                      borderRadius: "10px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "0 10px",
                      cursor: "pointer"
                    }}>
                    <span>
                      {date && dayjs.isDayjs(date)
                        ? dayjs(date).isSame(dayjs(), "day")
                          ? `${dayjs(date).format("MMM DD, YYYY")} (Today)`
                          : dayjs(date).format("MMM DD, YYYY")
                        : dayjs().format("MMM DD, YYYY")}
                    </span>
                    <InsertInvitationIcon
                      sx={{
                        color: selectedClientData?.AccentColor,
                        cursor: "pointer"
                      }}
                    />
                  </Box>

                  {/* Hidden DatePicker for functionality */}
                  <MobileDatePicker
                    open={open}
                    onOpen={() => setOpen(true)}
                    onClose={() => setOpen(false)}
                    format="MMM DD, YYYY"
                    value={date}
                    onChange={(newValue) => setDate(newValue)}
                    defaultValue={dayjs()}
                    sx={{ display: "none" }} // Hide the actual picker input
                  />
                </LocalizationProvider>
              </Grid>

              <Grid size={12}>
                <Typography margin={0} variant="subtitle1" gutterBottom>
                  {TEXT_DESCRIPTION}
                </Typography>
                <TextField
                  fullWidth
                  slotProps={{
                    input: {
                      rows: 4,
                      multiline: true,
                      inputComponent: "textarea"
                    }
                  }}
                  sx={{
                    backgroundColor: "#e4e4e4",
                    borderRadius: "10px",
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "0",
                      padding: " 5px 10px"
                    },
                    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                      border: "none"
                    }
                  }}
                  rows={5}
                  placeholder={TEXT_CHANGE_IS_REQUIRED}
                  value={description}
                  onChange={(e) => {
                    let inputValue = e.target.value;
                    inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, "");
                    setDescription(inputValue);
                  }}
                />
              </Grid>

              <Grid display={"flex"} size={12} gap={2} marginTop={2}>
                <div
                  onClick={handleAddImage}
                  style={{
                    cursor: "pointer",
                    height: "100px",
                    minWidth: "100px",
                    border: "2px solid #e4e4e4",
                    borderRadius: "10px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}>
                  <AddIcon />
                </div>
                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                    maxWidth: "100%",
                    scrollbarWidth: "none",
                    overflow: "scroll"
                  }}>
                  {uploadedImageList?.map((picture, index) => (
                    <div style={{ position: "relative", height: "100px" }} key={index}>
                      <ImageComponent
                        picture={picture}
                        setIndex={setIndex}
                        i={index}
                        setPictureView={setPictureView}
                      />
                      <IconButton
                        onClick={() => handleRemoveImage(picture, index)}
                        style={{
                          position: "absolute",
                          top: 0,
                          right: 0,
                          padding: "5px",
                          backgroundColor: BILightGrey,
                          color:
                            selectedClientData?.AccentColor !== undefined &&
                              selectedClientData?.AccentColor
                              ? selectedClientData?.AccentColor
                              : BILightGrey,
                        }}>
                        <CloseIcon style={{ fontSize: "16px" }} />
                      </IconButton>
                    </div>
                  ))}
                </div>
              </Grid>
              <Grid>
                <LoadingButton
                  onClick={handelsaveClientTracker}
                  fullWidth
                  startIcon={<></>}
                  style={{
                    textTransform: "none",
                    marginTop: "10px",
                    background:
                      description.trim() === "" ? "lightgrey" : selectedClientData?.AccentColor,
                    color: "white",
                    borderRadius: "10px",
                    boxShadow: "none"
                  }}
                  disabled={description === ""}
                  loadingPosition="start"
                  loading={loading}
                  variant="contained">
                  {TEXT_SUBMIT}
                </LoadingButton>
              </Grid>
            </Grid>
            <PictureViewer
              isOpen={pictureView}
              onClose={() => setPictureView(false)}
              pictures={uploadedImageList?.map((item) => {
                return { src: URL.createObjectURL(item) };
              })}
              viewerIndex={index}
            />

            <input
              type="file"
              accept="image/*"
              onChange={handleImageChange}
              ref={imgRef}
              style={{ display: "none" }}
              multiple
            />
          </Stack>
        </div>
      </Modal>
    </>
  );
}

const ImageComponent = memo(function MyComponent({ picture, setIndex, i, setPictureView }) {
  const ImgUrl = (file) => {
    try {
      let url = URL.createObjectURL(file);
      return url;
    } catch (error) {
      return file;
    }
  };

  return (
    <img
      loading="lazy"
      onClick={() => {
        setIndex(i);
        setPictureView(true);
      }}
      src={ImgUrl(picture)}
      alt={"NO data"}
      style={{
        width: "100px",
        height: "100px",
        borderRadius: "10px"
      }}
    />
  );
});
